export class TypeScriptCompileError extends Error {}
